export default "__VITE_ASSET__CJN9WDJW__"